export const LANGUAGES = [
  {
    code: "en",
    native: "English",
    label: "Default",
    icon: "Aa",
    bg: "#dbe7ff",
  },
  { code: "hi", native: "हिन्दी", label: "Hindi", icon: "अ", bg: "#fde0e3" },
  { code: "kn", native: "ಕನ್ನಡ", label: "Kannada", icon: "ಕ", bg: "#d9efe3" },
  { code: "ta", native: "தமிழ்", label: "Tamil", icon: "அ", bg: "#fde0e3" },
  { code: "te", native: "తెలుగు", label: "Telugu", icon: "అ", bg: "#d5f0ee" },
  {
    code: "ml",
    native: "മലയാളം",
    label: "Malayalam",
    icon: "അ",
    bg: "#d5f0ee",
  },
  { code: "mr", native: "मराठी", label: "Marathi", icon: "म", bg: "#fdebd3" },
  { code: "bn", native: "বাংলা", label: "Bengali", icon: "অ", bg: "#e6e3f7" },
  {
    code: "gu",
    native: "ગુજરાતી",
    label: "Gujarati",
    icon: "અ",
    bg: "#e6e3f7",
  },
  { code: "pa", native: "ਪੰਜਾਬੀ", label: "Punjabi", icon: "ਪ", bg: "#fdebd3" },
  {
    code: "as",
    native: "অসমীয়া",
    label: "Assamese",
    icon: "অ",
    bg: "#e6e3f7",
  },
  { code: "or", native: "ଓଡ଼ିଆ", label: "Odia", icon: "ଓ", bg: "#fde0e3" },
  {
    code: "sa",
    native: "संस्कृतम्",
    label: "Sanskrit",
    icon: "सं",
    bg: "#d5f0ee",
  },
];
export const translations = {
  en: {
    clickAny: "Click on any language",
    heroLine1: "India's 1st",
    heroLine2: "Home-grown",
    heroLine3: "Social Media App",
    heroSubtitle: "Every Voice Belongs on Bolo-India",
    heroDesc:
      "Share your thoughts, discover stories and connect with communities across India in the language you love.",
    aboutHeading: "Presenting India to the World.",
    aboutText:
      "Bolo-India is a vibrant social platform for every Indian to connect, share, and engage with one another on everything that celebrates our nation. Made in India, by Indians, for India, Bolo-India is built to amplify Indian voices, culture, ideas, and stories of our people & places. Whether it's news, entertainment, traditions, opinions, towns & villages or local communities, this is your space to express freely and connect proudly.",
    longsTitle: "LONGS",
    longsSubtitle: "120 Minutes of Stories Worth Staying For",
    longsDesc:
      "Dive into long videos & episodes of documentaries, interviews, travel films, culture and in-depth stories from across India.",
    minisTitle: "MINIS",
    minisSubtitle: "2 Minutes of Big Discoveries",
    minisDesc:
      "Dive into mini videos Catch quick moments, creative expressions, local talent and everyday life from every corner of India.",
    mini1: "Explore India",
    mini2: "Taste & Discover",
    mini3: "Culture & Talent",
    terms: "Terms of Use",
    privacy: "Privacy Policy",
  },
  hi: {
    clickAny: "किसी भी भाषा पर क्लिक करें",
    heroLine1: "भारत का पहला",
    heroLine2: "स्वदेशी सोशल",
    heroLine3: "मीडिया ऐप",
    heroSubtitle: "हर आवाज़ बोलो-इंडिया की है",
    heroDesc:
      "अपने विचार साझा करें, कहानियाँ खोजें और अपनी पसंदीदा भाषा में पूरे भारत के समुदायों से जुड़ें।",
    aboutHeading: "भारत को दुनिया के सामने पेश करते हुए।",
    aboutText:
      "बोलो-इंडिया हर भारतीय के लिए एक जीवंत सोशल प्लेटफ़ॉर्म है, जहाँ वे हमारे देश का गौरव बढ़ाने वाली हर चीज़ पर एक-दूसरे से जुड़ सकते हैं, अपनी बात साझा कर सकते हैं और संवाद कर सकते हैं। भारत में बना, भारतीयों द्वारा, भारत के लिए, बोलो-इंडिया को हमारे लोगों और स्थानों की आवाज़, संस्कृति, विचारों और कहानियों को बुलंद करने के लिए बनाया गया है। चाहे खबरें हों, मनोरंजन, परंपराएँ, राय, कस्बे और गाँव या स्थानीय समुदाय, यह आपकी अपनी जगह है जहाँ आप खुलकर अपनी बात रख सकते हैं और गर्व से जुड़ सकते हैं।",
    longsTitle: "लॉन्ग्स",
    longsSubtitle: "120 मिनट की कहानियाँ जो रुकने लायक हैं",
    longsDesc:
      "डॉक्यूमेंट्री, इंटरव्यू, ट्रैवल फ़िल्मों, संस्कृति और पूरे भारत की गहरी कहानियों के लंबे वीडियो और एपिसोड में डूब जाएँ।",
    minisTitle: "मिनीज़",
    minisSubtitle: "2 मिनट में बड़ी खोजें",
    minisDesc:
      "भारत के हर कोने के खास पल, रचनात्मक अभिव्यक्तियाँ, स्थानीय प्रतिभा और रोज़मर्रा का जीवन छोटे वीडियो में देखें।",
    mini1: "भारत देखें",
    mini2: "स्वाद और खोज",
    mini3: "संस्कृति और प्रतिभा",
    terms: "उपयोग की शर्तें",
    privacy: "गोपनीयता नीति",
  },
  kn: {
    clickAny: "ಯಾವುದೇ ಭಾಷೆಯ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ",
    heroLine1: "ಭಾರತದ ಮೊದಲ",
    heroLine2: "ಸ್ವದೇಶಿ ಸಾಮಾಜಿಕ",
    heroLine3: "ಮಾಧ್ಯಮ ಆಪ್",
    heroSubtitle: "ಪ್ರತಿ ಧ್ವನಿಯೂ ಬೋಲೋ-ಇಂಡಿಯಾಗೆ ಸೇರಿದೆ",
    heroDesc:
      "ನಿಮ್ಮ ಆಲೋಚನೆಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಿ, ಕಥೆಗಳನ್ನು ಅನ್ವೇಷಿಸಿ ಮತ್ತು ನೀವು ಇಷ್ಟಪಡುವ ಭಾಷೆಯಲ್ಲಿ ಭಾರತದಾದ್ಯಂತದ ಸಮುದಾಯಗಳೊಂದಿಗೆ ಸಂಪರ್ಕ ಸಾಧಿಸಿ.",
    aboutHeading: "ಭಾರತವನ್ನು ಜಗತ್ತಿಗೆ ಪರಿಚಯಿಸುತ್ತಿದೆ.",
    aboutText:
      "ಬೋಲೋ-ಇಂಡಿಯಾ ಪ್ರತಿಯೊಬ್ಬ ಭಾರತೀಯನೂ ನಮ್ಮ ದೇಶವನ್ನು ಸಂಭ್ರಮಿಸುವ ಎಲ್ಲದರ ಬಗ್ಗೆ ಪರಸ್ಪರ ಸಂಪರ್ಕಿಸಲು, ಹಂಚಿಕೊಳ್ಳಲು ಮತ್ತು ತೊಡಗಿಸಿಕೊಳ್ಳಲು ಇರುವ ಜೀವಂತ ಸಾಮಾಜಿಕ ವೇದಿಕೆ. ಭಾರತದಲ್ಲಿ ತಯಾರಾದ, ಭಾರತೀಯರಿಂದ, ಭಾರತಕ್ಕಾಗಿ, ಬೋಲೋ-ಇಂಡಿಯಾ ನಮ್ಮ ಜನರ ಮತ್ತು ಸ್ಥಳಗಳ ಧ್ವನಿ, ಸಂಸ್ಕೃತಿ, ಆಲೋಚನೆಗಳು ಮತ್ತು ಕಥೆಗಳನ್ನು ಹೆಚ್ಚಿಸಲು ನಿರ್ಮಿಸಲಾಗಿದೆ. ಸುದ್ದಿ, ಮನರಂಜನೆ, ಸಂಪ್ರದಾಯ, ಅಭಿಪ್ರಾಯಗಳು, ಪಟ್ಟಣ ಮತ್ತು ಹಳ್ಳಿಗಳು ಅಥವಾ ಸ್ಥಳೀಯ ಸಮುದಾಯಗಳು ಏನೇ ಇರಲಿ, ಇದು ನೀವು ಮುಕ್ತವಾಗಿ ಅಭಿವ್ಯಕ್ತಿಸಿ ಹೆಮ್ಮೆಯಿಂದ ಸಂಪರ್ಕ ಸಾಧಿಸುವ ನಿಮ್ಮ ಜಾಗ.",
    longsTitle: "ಲಾಂಗ್ಸ್",
    longsSubtitle: "ಉಳಿಯಲು ಯೋಗ್ಯವಾದ 120 ನಿಮಿಷಗಳ ಕಥೆಗಳು",
    longsDesc:
      "ಸಾಕ್ಷ್ಯಚಿತ್ರಗಳು, ಸಂದರ್ಶನಗಳು, ಪ್ರವಾಸ ಚಲನಚಿತ್ರಗಳು, ಸಂಸ್ಕೃತಿ ಮತ್ತು ಭಾರತದಾದ್ಯಂತದ ಆಳವಾದ ಕಥೆಗಳ ದೀರ್ಘ ವೀಡಿಯೊಗಳು ಮತ್ತು ಸಂಚಿಕೆಗಳಲ್ಲಿ ಮುಳುಗಿ.",
    minisTitle: "ಮಿನಿಸ್",
    minisSubtitle: "2 ನಿಮಿಷಗಳಲ್ಲಿ ದೊಡ್ಡ ಅನ್ವೇಷಣೆಗಳು",
    minisDesc:
      "ಭಾರತದ ಪ್ರತಿಯೊಂದು ಮೂಲೆಯ ಕ್ಷಣಗಳು, ಸೃಜನಶೀಲ ಅಭಿವ್ಯಕ್ತಿಗಳು, ಸ್ಥಳೀಯ ಪ್ರತಿಭೆ ಮತ್ತು ದೈನಂದಿನ ಜೀವನವನ್ನು ಚಿಕ್ಕ ವೀಡಿಯೊಗಳಲ್ಲಿ ನೋಡಿ.",
    mini1: "ಭಾರತವನ್ನು ಅನ್ವೇಷಿಸಿ",
    mini2: "ರುಚಿ ಮತ್ತು ಅನ್ವೇಷಣೆ",
    mini3: "ಸಂಸ್ಕೃತಿ ಮತ್ತು ಪ್ರತಿಭೆ",
    terms: "ಬಳಕೆಯ ನಿಯಮಗಳು",
    privacy: "ಗೌಪ್ಯತಾ ನೀತಿ",
  },
  ta: {
    clickAny: "ஏதேனும் ஒரு மொழியைக் கிளிக் செய்யவும்",
    heroLine1: "இந்தியாவின் முதல்",
    heroLine2: "சொந்த சமூக",
    heroLine3: "ஊடக செயலி",
    heroSubtitle: "ஒவ்வொரு குரலும் போலோ-இந்தியாவுக்குச் சொந்தம்",
    heroDesc:
      "உங்கள் எண்ணங்களைப் பகிருங்கள், கதைகளைக் கண்டறியுங்கள், நீங்கள் விரும்பும் மொழியில் இந்தியா முழுவதும் உள்ள சமூகங்களுடன் இணையுங்கள்.",
    aboutHeading: "இந்தியாவை உலகுக்கு அறிமுகப்படுத்துகிறோம்.",
    aboutText:
      "போலோ-இந்தியா என்பது ஒவ்வொரு இந்தியரும் நம் நாட்டைக் கொண்டாடும் அனைத்தையும் பற்றி இணையவும், பகிரவும், உரையாடவும் உதவும் துடிப்பான சமூக தளம். இந்தியாவில், இந்தியர்களால், இந்தியாவுக்காக உருவாக்கப்பட்ட போலோ-இந்தியா, நம் மக்களின் குரல்கள், கலாச்சாரம், யோசனைகள் மற்றும் கதைகளை உயர்த்த உருவாக்கப்பட்டது. செய்திகள், பொழுதுபோக்கு, மரபுகள், கருத்துகள், நகரங்கள் மற்றும் கிராமங்கள் அல்லது உள்ளூர் சமூகங்கள் எதுவாயினும், சுதந்திரமாக வெளிப்படுத்தி பெருமையுடன் இணைவதற்கான உங்கள் இடம் இது.",
    longsTitle: "லாங்ஸ்",
    longsSubtitle: "நின்று பார்க்கத் தகுந்த 120 நிமிடக் கதைகள்",
    longsDesc:
      "ஆவணப்படங்கள், நேர்காணல்கள், பயணத் திரைப்படங்கள், கலாச்சாரம் மற்றும் இந்தியா முழுவதும் உள்ள ஆழமான கதைகளின் நீண்ட வீடியோக்களிலும் எபிசோடுகளிலும் மூழ்குங்கள்.",
    minisTitle: "மினிஸ்",
    minisSubtitle: "2 நிமிடங்களில் பெரிய கண்டுபிடிப்புகள்",
    minisDesc:
      "இந்தியாவின் ஒவ்வொரு மூலையிலிருந்தும் விரைவான தருணங்கள், படைப்பாற்றல் வெளிப்பாடுகள், உள்ளூர் திறமைகள் மற்றும் அன்றாட வாழ்க்கையை சிறு வீடியோக்களில் காணுங்கள்.",
    mini1: "இந்தியாவை ஆராயுங்கள்",
    mini2: "சுவை & கண்டறிதல்",
    mini3: "கலாச்சாரம் & திறமை",
    terms: "பயன்பாட்டு விதிமுறைகள்",
    privacy: "தனியுரிமைக் கொள்கை",
  },
  te: {
    clickAny: "ఏదైనా భాషపై క్లిక్ చేయండి",
    heroLine1: "భారతదేశపు మొదటి",
    heroLine2: "స్వదేశీ సోషల్",
    heroLine3: "మీడియా యాప్",
    heroSubtitle: "ప్రతి స్వరం బోలో-ఇండియాకు చెందినదే",
    heroDesc:
      "మీ ఆలోచనలను పంచుకోండి, కథలను కనుగొనండి మరియు మీకు నచ్చిన భాషలో భారతదేశమంతటా ఉన్న సమాజాలతో అనుసంధానమవ్వండి.",
    aboutHeading: "భారతదేశాన్ని ప్రపంచానికి పరిచయం చేస్తున్నాం.",
    aboutText:
      "బోలో-ఇండియా ప్రతి భారతీయుడు మన దేశాన్ని జరుపుకునే ప్రతి విషయంపై ఒకరితో ఒకరు అనుసంధానమై, పంచుకుని, చర్చించుకునే సజీవ సామాజిక వేదిక. భారతదేశంలో, భారతీయులచే, భారతదేశం కోసం రూపొందిన బోలో-ఇండియా మన ప్రజల స్వరాలను, సంస్కృతిని, ఆలోచనలను, కథలను విస్తరించడానికి నిర్మించబడింది. వార్తలు, వినోదం, సంప్రదాయాలు, అభిప్రాయాలు, పట్టణాలు మరియు గ్రామాలు లేదా స్థానిక సమాజాలు ఏవైనా, స్వేచ్ఛగా వ్యక్తపరచి గర్వంగా అనుసంధానమయ్యే మీ స్థలం ఇది.",
    longsTitle: "లాంగ్స్",
    longsSubtitle: "ఆగి చూడదగిన 120 నిమిషాల కథలు",
    longsDesc:
      "డాక్యుమెంటరీలు, ఇంటర్వ్యూలు, ప్రయాణ చిత్రాలు, సంస్కృతి మరియు భారతదేశమంతటా లోతైన కథల పొడవైన వీడియోలు, ఎపిసోడ్‌లలో మునిగిపోండి.",
    minisTitle: "మినిస్",
    minisSubtitle: "2 నిమిషాల్లో పెద్ద ఆవిష్కరణలు",
    minisDesc:
      "భారతదేశంలోని ప్రతి మూల నుండి క్షణాలు, సృజనాత్మక వ్యక్తీకరణలు, స్థానిక ప్రతిభ మరియు రోజువారీ జీవితాన్ని చిన్న వీడియోలలో చూడండి.",
    mini1: "భారతదేశాన్ని అన్వేషించండి",
    mini2: "రుచి & ఆవిష్కరణ",
    mini3: "సంస్కృతి & ప్రతిభ",
    terms: "వినియోగ నిబంధనలు",
    privacy: "గోప్యతా విధానం",
  },
  ml: {
    clickAny: "ഏതെങ്കിലും ഭാഷയിൽ ക്ലിക്ക് ചെയ്യുക",
    heroLine1: "ഇന്ത്യയുടെ ആദ്യ",
    heroLine2: "സ്വദേശി സോഷ്യൽ",
    heroLine3: "മീഡിയ ആപ്പ്",
    heroSubtitle: "ഓരോ ശബ്ദവും ബോലോ-ഇന്ത്യയുടേതാണ്",
    heroDesc:
      "നിങ്ങളുടെ ചിന്തകൾ പങ്കുവെക്കൂ, കഥകൾ കണ്ടെത്തൂ, നിങ്ങൾക്കിഷ്ടമുള്ള ഭാഷയിൽ ഇന്ത്യയിലുടനീളമുള്ള സമൂഹങ്ങളുമായി ബന്ധപ്പെടൂ.",
    aboutHeading: "ഇന്ത്യയെ ലോകത്തിന് പരിചയപ്പെടുത്തുന്നു.",
    aboutText:
      "ബോലോ-ഇന്ത്യ ഓരോ ഇന്ത്യക്കാരനും നമ്മുടെ രാജ്യത്തെ ആഘോഷിക്കുന്ന എല്ലാറ്റിനെയും കുറിച്ച് പരസ്പരം ബന്ധപ്പെടാനും പങ്കുവെക്കാനും ഇടപഴകാനുമുള്ള സജീവമായ സോഷ്യൽ പ്ലാറ്റ്‌ഫോമാണ്. ഇന്ത്യയിൽ നിർമ്മിച്ച, ഇന്ത്യക്കാരാൽ, ഇന്ത്യക്കായി, നമ്മുടെ ജനങ്ങളുടെയും സ്ഥലങ്ങളുടെയും ശബ്ദം, സംസ്കാരം, ആശയങ്ങൾ, കഥകൾ എന്നിവ ഉയർത്താനാണ് ബോലോ-ഇന്ത്യ. വാർത്തകൾ, വിനോദം, പാരമ്പര്യങ്ങൾ, അഭിപ്രായങ്ങൾ, പട്ടണങ്ങളും ഗ്രാമങ്ങളും, പ്രാദേശിക സമൂഹങ്ങൾ — എന്തായാലും സ്വതന്ത്രമായി പ്രകടിപ്പിക്കാനും അഭിമാനത്തോടെ ബന്ധപ്പെടാനുമുള്ള നിങ്ങളുടെ ഇടമാണിത്.",
    longsTitle: "ലോങ്സ്",
    longsSubtitle: "ഇരുന്നു കാണാൻ യോഗ്യമായ 120 മിനിറ്റ് കഥകൾ",
    longsDesc:
      "ഡോക്യുമെന്ററികൾ, അഭിമുഖങ്ങൾ, യാത്രാ സിനിമകൾ, സംസ്കാരം, ഇന്ത്യയിലുടനീളമുള്ള ആഴമേറിയ കഥകൾ എന്നിവയുടെ നീണ്ട വീഡിയോകളിലും എപ്പിസോഡുകളിലും മുഴുകൂ.",
    minisTitle: "മിനിസ്",
    minisSubtitle: "2 മിനിറ്റിൽ വലിയ കണ്ടെത്തലുകൾ",
    minisDesc:
      "ഇന്ത്യയുടെ ഓരോ കോണിൽ നിന്നുമുള്ള പെട്ടെന്നുള്ള നിമിഷങ്ങൾ, സർഗ്ഗാത്മക ആവിഷ്കാരങ്ങൾ, പ്രാദേശിക പ്രതിഭ, ദൈനംദിന ജീവിതം എന്നിവ ചെറു വീഡിയോകളിൽ കാണൂ.",
    mini1: "ഇന്ത്യ കണ്ടെത്തൂ",
    mini2: "രുചിയും കണ്ടെത്തലും",
    mini3: "സംസ്കാരവും പ്രതിഭയും",
    terms: "ഉപയോഗ നിബന്ധനകൾ",
    privacy: "സ്വകാര്യതാ നയം",
  },
  mr: {
    clickAny: "कोणत्याही भाषेवर क्लिक करा",
    heroLine1: "भारताचे पहिले",
    heroLine2: "स्वदेशी सोशल",
    heroLine3: "मीडिया ॲप",
    heroSubtitle: "प्रत्येक आवाज बोलो-इंडियाचा आहे",
    heroDesc:
      "तुमचे विचार शेअर करा, कथा शोधा आणि तुमच्या आवडत्या भाषेत संपूर्ण भारतातील समुदायांशी जोडले जा.",
    aboutHeading: "भारताला जगासमोर सादर करत आहोत.",
    aboutText:
      "बोलो-इंडिया हे प्रत्येक भारतीयासाठी आपल्या देशाचा अभिमान वाटणाऱ्या प्रत्येक गोष्टीवर एकमेकांशी जोडले जाण्यासाठी, शेअर करण्यासाठी आणि संवाद साधण्यासाठी एक जिवंत सोशल प्लॅटफॉर्म आहे. भारतात बनलेले, भारतीयांनी, भारतासाठी, बोलो-इंडिया आपल्या लोकांचे आणि ठिकाणांचे आवाज, संस्कृती, विचार आणि कथा वाढवण्यासाठी बनवले आहे. बातम्या, मनोरंजन, परंपरा, मते, शहरे आणि गावे किंवा स्थानिक समुदाय — हे तुमचे मोकळेपणाने व्यक्त होण्याचे आणि अभिमानाने जोडले जाण्याचे स्थान आहे.",
    longsTitle: "लाँग्स",
    longsSubtitle: "थांबून पाहण्यासारख्या 120 मिनिटांच्या कथा",
    longsDesc:
      "माहितीपट, मुलाखती, प्रवास चित्रपट, संस्कृती आणि संपूर्ण भारतातील सखोल कथांच्या दीर्घ व्हिडिओ आणि भागांमध्ये रमून जा.",
    minisTitle: "मिनीज",
    minisSubtitle: "2 मिनिटांत मोठे शोध",
    minisDesc:
      "भारताच्या प्रत्येक कोपऱ्यातील झटपट क्षण, सर्जनशील अभिव्यक्ती, स्थानिक प्रतिभा आणि रोजचे जीवन छोट्या व्हिडिओंमध्ये पाहा.",
    mini1: "भारत एक्सप्लोर करा",
    mini2: "चव आणि शोध",
    mini3: "संस्कृती आणि प्रतिभा",
    terms: "वापराच्या अटी",
    privacy: "गोपनीयता धोरण",
  },
  bn: {
    clickAny: "যেকোনো ভাষায় ক্লিক করুন",
    heroLine1: "ভারতের প্রথম",
    heroLine2: "নিজস্ব সোশ্যাল",
    heroLine3: "মিডিয়া অ্যাপ",
    heroSubtitle: "প্রতিটি কণ্ঠস্বর বোলো-ইন্ডিয়ার",
    heroDesc:
      "আপনার ভাবনা শেয়ার করুন, গল্প আবিষ্কার করুন এবং আপনার পছন্দের ভাষায় সারা ভারতের কমিউনিটির সাথে যুক্ত হন।",
    aboutHeading: "ভারতকে বিশ্বের সামনে তুলে ধরছি।",
    aboutText:
      "বোলো-ইন্ডিয়া প্রতিটি ভারতীয়র জন্য এমন একটি প্রাণবন্ত সামাজিক প্ল্যাটফর্ম, যেখানে আমাদের দেশকে উদযাপন করা সবকিছু নিয়ে একে অপরের সঙ্গে যুক্ত হওয়া, শেয়ার করা ও আলোচনা করা যায়। ভারতে তৈরি, ভারতীয়দের দ্বারা, ভারতের জন্য, বোলো-ইন্ডিয়া আমাদের মানুষ ও স্থানের কণ্ঠস্বর, সংস্কৃতি, ভাবনা ও গল্পকে তুলে ধরতে তৈরি। খবর, বিনোদন, ঐতিহ্য, মতামত, শহর ও গ্রাম বা স্থানীয় সম্প্রদায় — এটি আপনার নিজের জায়গা, যেখানে মন খুলে প্রকাশ করা ও গর্বের সঙ্গে যুক্ত হওয়া যায়।",
    longsTitle: "লংস",
    longsSubtitle: "থেমে দেখার মতো 120 মিনিটের গল্প",
    longsDesc:
      "প্রামাণ্যচিত্র, সাক্ষাৎকার, ভ্রমণ চলচ্চিত্র, সংস্কৃতি এবং সারা ভারতের গভীর গল্পের দীর্ঘ ভিডিও ও পর্বে ডুব দিন।",
    minisTitle: "মিনিস",
    minisSubtitle: "2 মিনিটে বড় আবিষ্কার",
    minisDesc:
      "ভারতের প্রতিটি কোণের মুহূর্ত, সৃজনশীল প্রকাশ, স্থানীয় প্রতিভা এবং দৈনন্দিন জীবন ছোট ভিডিওতে দেখুন।",
    mini1: "ভারত ঘুরে দেখুন",
    mini2: "স্বাদ ও আবিষ্কার",
    mini3: "সংস্কৃতি ও প্রতিভা",
    terms: "ব্যবহারের শর্তাবলী",
    privacy: "গোপনীয়তা নীতি",
  },
  gu: {
    clickAny: "કોઈપણ ભાષા પર ક્લિક કરો",
    heroLine1: "ભારતની પ્રથમ",
    heroLine2: "સ્વદેશી સોશિયલ",
    heroLine3: "મીડિયા એપ",
    heroSubtitle: "દરેક અવાજ બોલો-ઇન્ડિયાનો છે",
    heroDesc:
      "તમારા વિચારો શેર કરો, વાર્તાઓ શોધો અને તમારી પસંદની ભાષામાં સમગ્ર ભારતના સમુદાયો સાથે જોડાઓ.",
    aboutHeading: "ભારતને વિશ્વ સમક્ષ રજૂ કરી રહ્યા છીએ.",
    aboutText:
      "બોલો-ઇન્ડિયા દરેક ભારતીય માટે આપણા દેશની ઉજવણી કરતી દરેક બાબત પર એકબીજા સાથે જોડાવા, શેર કરવા અને સંવાદ કરવા માટેનું જીવંત સોશિયલ પ્લેટફોર્મ છે. ભારતમાં બનેલું, ભારતીયો દ્વારા, ભારત માટે, બોલો-ઇન્ડિયા આપણા લોકો અને સ્થળોના અવાજ, સંસ્કૃતિ, વિચારો અને વાર્તાઓને બુલંદ કરવા બનાવાયું છે. સમાચાર, મનોરંજન, પરંપરાઓ, અભિપ્રાયો, નગરો અને ગામડાં કે સ્થાનિક સમુદાયો — આ તમારું પોતાનું સ્થાન છે જ્યાં તમે મુક્તપણે વ્યક્ત થઈ ગર્વથી જોડાઈ શકો.",
    longsTitle: "લોંગ્સ",
    longsSubtitle: "રોકાઈને જોવા જેવી 120 મિનિટની વાર્તાઓ",
    longsDesc:
      "દસ્તાવેજી, ઇન્ટરવ્યૂ, પ્રવાસ ફિલ્મો, સંસ્કૃતિ અને સમગ્ર ભારતની ઊંડી વાર્તાઓના લાંબા વીડિયો અને એપિસોડમાં ડૂબી જાઓ.",
    minisTitle: "મિનીઝ",
    minisSubtitle: "2 મિનિટમાં મોટી શોધ",
    minisDesc:
      "ભારતના દરેક ખૂણાની પળો, સર્જનાત્મક અભિવ્યક્તિઓ, સ્થાનિક પ્રતિભા અને રોજિંદા જીવનને નાના વીડિયોમાં જુઓ.",
    mini1: "ભારત શોધો",
    mini2: "સ્વાદ અને શોધ",
    mini3: "સંસ્કૃતિ અને પ્રતિભા",
    terms: "ઉપયોગની શરતો",
    privacy: "ગોપનીયતા નીતિ",
  },
  pa: {
    clickAny: "ਕਿਸੇ ਵੀ ਭਾਸ਼ਾ 'ਤੇ ਕਲਿੱਕ ਕਰੋ",
    heroLine1: "ਭਾਰਤ ਦਾ ਪਹਿਲਾ",
    heroLine2: "ਸਵਦੇਸ਼ੀ ਸੋਸ਼ਲ",
    heroLine3: "ਮੀਡੀਆ ਐਪ",
    heroSubtitle: "ਹਰ ਆਵਾਜ਼ ਬੋਲੋ-ਇੰਡੀਆ ਦੀ ਹੈ",
    heroDesc:
      "ਆਪਣੇ ਵਿਚਾਰ ਸਾਂਝੇ ਕਰੋ, ਕਹਾਣੀਆਂ ਲੱਭੋ ਅਤੇ ਆਪਣੀ ਪਸੰਦ ਦੀ ਭਾਸ਼ਾ ਵਿੱਚ ਪੂਰੇ ਭਾਰਤ ਦੇ ਭਾਈਚਾਰਿਆਂ ਨਾਲ ਜੁੜੋ।",
    aboutHeading: "ਭਾਰਤ ਨੂੰ ਦੁਨੀਆ ਸਾਹਮਣੇ ਪੇਸ਼ ਕਰ ਰਹੇ ਹਾਂ।",
    aboutText:
      "ਬੋਲੋ-ਇੰਡੀਆ ਹਰ ਭਾਰਤੀ ਲਈ ਸਾਡੇ ਦੇਸ਼ ਦਾ ਜਸ਼ਨ ਮਨਾਉਣ ਵਾਲੀ ਹਰ ਚੀਜ਼ ਬਾਰੇ ਇੱਕ-ਦੂਜੇ ਨਾਲ ਜੁੜਨ, ਸਾਂਝਾ ਕਰਨ ਅਤੇ ਗੱਲਬਾਤ ਕਰਨ ਲਈ ਇੱਕ ਜੀਵੰਤ ਸੋਸ਼ਲ ਪਲੇਟਫਾਰਮ ਹੈ। ਭਾਰਤ ਵਿੱਚ ਬਣਿਆ, ਭਾਰਤੀਆਂ ਦੁਆਰਾ, ਭਾਰਤ ਲਈ, ਬੋਲੋ-ਇੰਡੀਆ ਸਾਡੇ ਲੋਕਾਂ ਅਤੇ ਥਾਵਾਂ ਦੀ ਆਵਾਜ਼, ਸੱਭਿਆਚਾਰ, ਵਿਚਾਰਾਂ ਅਤੇ ਕਹਾਣੀਆਂ ਨੂੰ ਬੁਲੰਦ ਕਰਨ ਲਈ ਬਣਾਇਆ ਗਿਆ ਹੈ। ਖ਼ਬਰਾਂ, ਮਨੋਰੰਜਨ, ਪਰੰਪਰਾਵਾਂ, ਰਾਏ, ਕਸਬੇ ਅਤੇ ਪਿੰਡ ਜਾਂ ਸਥਾਨਕ ਭਾਈਚਾਰੇ — ਇਹ ਤੁਹਾਡੀ ਆਪਣੀ ਥਾਂ ਹੈ ਜਿੱਥੇ ਖੁੱਲ੍ਹ ਕੇ ਆਪਣੀ ਗੱਲ ਕਹੋ ਅਤੇ ਮਾਣ ਨਾਲ ਜੁੜੋ।",
    longsTitle: "ਲੌਂਗਸ",
    longsSubtitle: "ਰੁਕ ਕੇ ਦੇਖਣ ਯੋਗ 120 ਮਿੰਟ ਦੀਆਂ ਕਹਾਣੀਆਂ",
    longsDesc:
      "ਡਾਕੂਮੈਂਟਰੀਆਂ, ਇੰਟਰਵਿਊਆਂ, ਯਾਤਰਾ ਫ਼ਿਲਮਾਂ, ਸੱਭਿਆਚਾਰ ਅਤੇ ਪੂਰੇ ਭਾਰਤ ਦੀਆਂ ਡੂੰਘੀਆਂ ਕਹਾਣੀਆਂ ਦੇ ਲੰਬੇ ਵੀਡੀਓ ਅਤੇ ਐਪੀਸੋਡਾਂ ਵਿੱਚ ਡੁੱਬ ਜਾਓ।",
    minisTitle: "ਮਿਨੀਜ਼",
    minisSubtitle: "2 ਮਿੰਟਾਂ ਵਿੱਚ ਵੱਡੀਆਂ ਖੋਜਾਂ",
    minisDesc:
      "ਭਾਰਤ ਦੇ ਹਰ ਕੋਨੇ ਦੇ ਪਲ, ਰਚਨਾਤਮਕ ਪ੍ਰਗਟਾਵੇ, ਸਥਾਨਕ ਪ੍ਰਤਿਭਾ ਅਤੇ ਰੋਜ਼ਾਨਾ ਜੀਵਨ ਛੋਟੇ ਵੀਡੀਓਆਂ ਵਿੱਚ ਦੇਖੋ।",
    mini1: "ਭਾਰਤ ਦੇਖੋ",
    mini2: "ਸੁਆਦ ਅਤੇ ਖੋਜ",
    mini3: "ਸੱਭਿਆਚਾਰ ਅਤੇ ਪ੍ਰਤਿਭਾ",
    terms: "ਵਰਤੋਂ ਦੀਆਂ ਸ਼ਰਤਾਂ",
    privacy: "ਗੋਪਨੀਯਤਾ ਨੀਤੀ",
  },
  as: {
    clickAny: "যিকোনো ভাষাত ক্লিক কৰক",
    heroLine1: "ভাৰতৰ প্ৰথম",
    heroLine2: "নিজা ছচিয়েল",
    heroLine3: "মিডিয়া এপ",
    heroSubtitle: "প্ৰতিটো মাত বোলো-ইণ্ডিয়াৰ",
    heroDesc:
      "আপোনাৰ চিন্তা ভাগ-বতৰা কৰক, কাহিনী আৱিষ্কাৰ কৰক আৰু আপুনি ভাল পোৱা ভাষাত সমগ্ৰ ভাৰতৰ সমাজবোৰৰ সৈতে সংযুক্ত হওক।",
    aboutHeading: "ভাৰতক বিশ্বৰ আগত উপস্থাপন কৰি আছোঁ।",
    aboutText:
      "বোলো-ইণ্ডিয়া প্ৰতিজন ভাৰতীয়ৰ বাবে আমাৰ দেশক উদযাপন কৰা সকলোবোৰ কথাত ইজনে সিজনৰ সৈতে সংযুক্ত হ'বলৈ, ভাগ-বতৰা কৰিবলৈ আৰু আলোচনা কৰিবলৈ এটা প্ৰাণৱন্ত সামাজিক মঞ্চ। ভাৰতত নিৰ্মিত, ভাৰতীয়ৰ দ্বাৰা, ভাৰতৰ বাবে, বোলো-ইণ্ডিয়া আমাৰ মানুহ আৰু ঠাইৰ মাত, সংস্কৃতি, ধাৰণা আৰু কাহিনীক ওপৰলৈ তুলি ধৰিবলৈ নিৰ্মাণ কৰা হৈছে। সংবাদ, মনোৰঞ্জন, পৰম্পৰা, মতামত, নগৰ আৰু গাঁও বা স্থানীয় সমাজ — এয়া আপোনাৰ নিজা ঠাই, য'ত মুক্তভাৱে প্ৰকাশ কৰি গৌৰৱেৰে সংযুক্ত হ'ব পাৰে।",
    longsTitle: "লংচ",
    longsSubtitle: "ৰৈ চাবলগীয়া 120 মিনিটৰ কাহিনী",
    longsDesc:
      "প্ৰামাণ্যচিত্ৰ, সাক্ষাৎকাৰ, ভ্ৰমণ চলচ্চিত্ৰ, সংস্কৃতি আৰু সমগ্ৰ ভাৰতৰ গভীৰ কাহিনীৰ দীঘলীয়া ভিডিঅ' আৰু পৰ্বত ডুব যাওক।",
    minisTitle: "মিনিচ",
    minisSubtitle: "2 মিনিটত ডাঙৰ আৱিষ্কাৰ",
    minisDesc:
      "ভাৰতৰ প্ৰতিটো কোণৰ মুহূৰ্ত, সৃজনশীল প্ৰকাশ, স্থানীয় প্ৰতিভা আৰু দৈনন্দিন জীৱন চুটি ভিডিঅ'ত চাওক।",
    mini1: "ভাৰত অন্বেষণ কৰক",
    mini2: "সোৱাদ আৰু আৱিষ্কাৰ",
    mini3: "সংস্কৃতি আৰু প্ৰতিভা",
    terms: "ব্যৱহাৰৰ চৰ্তাৱলী",
    privacy: "গোপনীয়তা নীতি",
  },
  or: {
    clickAny: "ଯେକୌଣସି ଭାଷାରେ କ୍ଲିକ୍ କରନ୍ତୁ",
    heroLine1: "ଭାରତର ପ୍ରଥମ",
    heroLine2: "ସ୍ୱଦେଶୀ ସୋସିଆଲ",
    heroLine3: "ମିଡିଆ ଆପ୍",
    heroSubtitle: "ପ୍ରତ୍ୟେକ ସ୍ୱର ବୋଲୋ-ଇଣ୍ଡିଆର",
    heroDesc:
      "ଆପଣଙ୍କ ଚିନ୍ତାଧାରା ସେୟାର କରନ୍ତୁ, କାହାଣୀ ଆବିଷ୍କାର କରନ୍ତୁ ଏବଂ ଆପଣ ପସନ୍ଦ କରୁଥିବା ଭାଷାରେ ସମଗ୍ର ଭାରତର ସମ୍ପ୍ରଦାୟ ସହିତ ଯୋଗ ଦିଅନ୍ତୁ।",
    aboutHeading: "ଭାରତକୁ ବିଶ୍ୱ ସାମ୍ନାରେ ଉପସ୍ଥାପନ କରୁଛୁ।",
    aboutText:
      "ବୋଲୋ-ଇଣ୍ଡିଆ ପ୍ରତ୍ୟେକ ଭାରତୀୟଙ୍କ ପାଇଁ ଆମ ଦେଶକୁ ଉତ୍ସବ କରୁଥିବା ସବୁ ବିଷୟରେ ପରସ୍ପର ସହ ଯୋଗାଯୋଗ, ସେୟାର ଓ ଆଲୋଚନା କରିବା ପାଇଁ ଏକ ଜୀବନ୍ତ ସାମାଜିକ ମଞ୍ଚ। ଭାରତରେ ନିର୍ମିତ, ଭାରତୀୟଙ୍କ ଦ୍ୱାରା, ଭାରତ ପାଇଁ, ବୋଲୋ-ଇଣ୍ଡିଆ ଆମ ଲୋକ ଓ ସ୍ଥାନର ସ୍ୱର, ସଂସ୍କୃତି, ଚିନ୍ତାଧାରା ଓ କାହାଣୀକୁ ଉଚ୍ଚକୁ ନେବା ପାଇଁ ତିଆରି। ଖବର, ମନୋରଞ୍ଜନ, ପରମ୍ପରା, ମତାମତ, ସହର ଓ ଗାଁ କିମ୍ବା ସ୍ଥାନୀୟ ସମ୍ପ୍ରଦାୟ — ଏହା ଆପଣଙ୍କର ନିଜ ସ୍ଥାନ, ଯେଉଁଠାରେ ମୁକ୍ତ ଭାବେ ପ୍ରକାଶ କରି ଗର୍ବରେ ଯୋଗ ଦେଇପାରିବେ।",
    longsTitle: "ଲଙ୍ଗ୍ସ",
    longsSubtitle: "ରହି ଦେଖିବା ଯୋଗ୍ୟ 120 ମିନିଟର କାହାଣୀ",
    longsDesc:
      "ଡକ୍ୟୁମେଣ୍ଟାରୀ, ସାକ୍ଷାତକାର, ଭ୍ରମଣ ଚଳଚ୍ଚିତ୍ର, ସଂସ୍କୃତି ଏବଂ ସମଗ୍ର ଭାରତର ଗଭୀର କାହାଣୀର ଲମ୍ବା ଭିଡିଓ ଓ ଏପିସୋଡରେ ଡୁବିଯାଆନ୍ତୁ।",
    minisTitle: "ମିନିସ୍",
    minisSubtitle: "2 ମିନିଟରେ ବଡ଼ ଆବିଷ୍କାର",
    minisDesc:
      "ଭାରତର ପ୍ରତ୍ୟେକ କୋଣର ମୁହୂର୍ତ୍ତ, ସୃଜନଶୀଳ ଅଭିବ୍ୟକ୍ତି, ସ୍ଥାନୀୟ ପ୍ରତିଭା ଓ ଦୈନନ୍ଦିନ ଜୀବନକୁ ଛୋଟ ଭିଡିଓରେ ଦେଖନ୍ତୁ।",
    mini1: "ଭାରତ ଅନ୍ୱେଷଣ କରନ୍ତୁ",
    mini2: "ସ୍ୱାଦ ଓ ଆବିଷ୍କାର",
    mini3: "ସଂସ୍କୃତି ଓ ପ୍ରତିଭା",
    terms: "ବ୍ୟବହାର ନିୟମାବଳୀ",
    privacy: "ଗୋପନୀୟତା ନୀତି",
  },
  sa: {
    clickAny: "कस्यामपि भाषायां क्लिक् कुर्वन्तु",
    heroLine1: "भारतस्य प्रथमम्",
    heroLine2: "स्वदेशीयं सामाजिक",
    heroLine3: "माध्यम-ऐप्",
    heroSubtitle: "प्रत्येकं स्वरः बोलो-इण्डियायाः अस्ति",
    heroDesc:
      "स्वविचारान् साझां कुर्वन्तु, कथाः अन्विषन्तु, स्वप्रियभाषायां च सम्पूर्णभारतस्य समुदायैः सह संयुज्यन्तु।",
    aboutHeading: "भारतं विश्वस्य पुरतः प्रस्तुवन्तः।",
    aboutText:
      "बोलो-इण्डिया प्रत्येकस्य भारतीयस्य कृते अस्माकं राष्ट्रं यत् उत्सवयति तस्मिन् सर्वस्मिन् परस्परं संयोजनाय, साझाकरणाय, संवादाय च जीवन्तं सामाजिकं मञ्चम् अस्ति। भारते निर्मितम्, भारतीयैः, भारताय, बोलो-इण्डिया अस्माकं जनानां स्थानानां च स्वरान्, संस्कृतिं, विचारान्, कथाश्च उन्नेतुं निर्मितम्। वार्ताः, मनोरञ्जनं, परम्पराः, मतानि, नगराणि ग्रामाश्च स्थानीयसमुदायाः वा — इदं भवतः स्वकीयं स्थानम् अस्ति यत्र निर्भयं स्वमतं प्रकाशयित्वा गर्वेण संयोक्तुं शक्यते।",
    longsTitle: "लोङ्ग्स्",
    longsSubtitle: "स्थित्वा द्रष्टुं योग्याः 120 निमेषाणां कथाः",
    longsDesc:
      "वृत्तचित्राणां, साक्षात्काराणां, यात्राचित्राणां, संस्कृतेः, सम्पूर्णभारतस्य गभीरकथानां च दीर्घेषु वीडियोषु भागेषु च निमज्जन्तु।",
    minisTitle: "मिनीस्",
    minisSubtitle: "2 निमेषेषु महान्तः आविष्काराः",
    minisDesc:
      "भारतस्य प्रत्येकस्मात् कोणात् क्षणान्, सृजनात्मकाभिव्यक्तीः, स्थानीयप्रतिभां, दैनन्दिनजीवनं च लघुवीडियोषु पश्यन्तु।",
    mini1: "भारतम् अन्विषन्तु",
    mini2: "रसः अन्वेषणं च",
    mini3: "संस्कृतिः प्रतिभा च",
    terms: "उपयोगस्य नियमाः",
    privacy: "गोपनीयता-नीतिः",
  },
};
